/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { compose } from 'recompose';
import { connect, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import { object, string } from 'prop-types';
import { getSSRDeviceType } from '../../../../../../../state/ducks/App/App-Selectors';
import { getFeatureFlag } from '../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import ScrollbarContainer from '../../../../GraphqlCategoryPage/Partials/ScrollbarContainer/ScrollbarContainer';

const useStyles = makeStyles((theme) => ({
    contentTop: {
        // Desktop
        margin: '0px auto',
        maxWidth: '1380px',
        color: theme.palette.black,
        // Tablet
        [theme.breakpoints.down('md')]: {
            margin: '20px 20px 30px',
        },
        // Mobile
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
        },
        [theme.breakpoints.down('sm')]: {
            margin: '0 0 10px 0',
        },
    },
    contentLeft: {
        width: '100%',
        // Tablet
        [theme.breakpoints.down('md')]: {
            flex: '1 1 auto',
            display: 'flex',
            maxWidth: '100%',
            marginRight: '20px',
            flexDirection: 'column',
        },
        // Mobile
        [theme.breakpoints.down(600)]: {
            maxWidth: '100%',
        },
        marginRight: '24px',
        maxWidth: '665px',
    },
    contentRight: {
        width: '100%',
        maxWidth: '980px',
        // Tablet
        [theme.breakpoints.down('md')]: {
            width: 'calc(60% - 20px)',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
        },
        // Mobile
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            height: '100%',
        },
    },
}));

const TwoColumn = (props) => {
    const {
        ssrDeviceType,
        components,
    } = props;

    const {
        ProductImageUI,
        ProductTitle,
        ProductReview,
        GraphqlProductSkus,
        GraphqlAddonContainer,
        GCIPersonalization,
        SnipeBanner,
        GraphqlAgeVerification,
        SubscriptionProductBannerUI,
        PersonalizeYourGift,
        ProductQuantity,
        GraphqlPDPPromoContainer,
        PmallSummary,
        PmallPersonalization,
        PDPAddToCart,
        GoDeluxe,
        NBCUMovieBanner,
        SubstitutionMessage,
        PLAProductIcon,
    } = components;

    const classes = useStyles();

    // PowerReviews Flags
    const isPDPReviewsEnabled = useSelector(getFeatureFlag(['is-pdp-reviews-enabled']));
    const isPowerReviewEnabled = useSelector(getFeatureFlag(['is-power-review-enabled']));

    const desktopLayout = () => (
        <div
            className={classes.contentTop}
            data-testid="pdp-variant-twocolumn"
        >
            <ScrollbarContainer
                contentContainerId="twoColumnRight"
                isFoodBrand
                type="productBase"
            >
                <div className={classes.contentLeft}>
                    {ProductImageUI()}
                    {SubstitutionMessage()}
                </div>
            </ScrollbarContainer>
            <div className={classes.contentRight} id="twoColumnRight">
                {ProductTitle()}
                {isPDPReviewsEnabled && isPowerReviewEnabled && ProductReview()}
                {GraphqlProductSkus()}
                {GraphqlAddonContainer()}
                {GCIPersonalization()}
                {SnipeBanner()}
                {GraphqlAgeVerification()}
                {SubscriptionProductBannerUI()}
                {PersonalizeYourGift()}
                {PmallSummary()}
                {GraphqlPDPPromoContainer()}
                {PmallPersonalization()}
                {ProductQuantity()}
                {PDPAddToCart()}
                {NBCUMovieBanner()}
            </div>
        </div>
    );

    const mobileLayout = () => (
        <>
            {PLAProductIcon()}
            <div className={classes.contentTop}>
                <div className={classes.contentLeft}>
                    <div id="productImage">{ProductImageUI()}</div>
                </div>
                <div className={classes.contentRight}>
                    {ProductTitle()}
                    {isPDPReviewsEnabled && isPowerReviewEnabled && ProductReview()}
                    {GraphqlProductSkus()}
                    {GoDeluxe(null, true)}
                    {GraphqlAddonContainer()}
                    {GCIPersonalization()}
                    {SnipeBanner()}
                    {GraphqlAgeVerification()}
                    {SubscriptionProductBannerUI()}
                    {PersonalizeYourGift()}
                    {PmallSummary()}
                    {GraphqlPDPPromoContainer()}
                    {PmallPersonalization()}
                    {ProductQuantity()}
                    {PDPAddToCart()}
                    {NBCUMovieBanner()}
                    {SubstitutionMessage()}
                    {GoDeluxe()}
                </div>
            </div>
        </>
    );

    if (ssrDeviceType === 'mobile') {
        return mobileLayout();
    }

    return desktopLayout();
};

const mapStateToProps = (state) => ({
    ssrDeviceType: getSSRDeviceType(state),
});

TwoColumn.propTypes = {
    ssrDeviceType: string.isRequired,
    components: object.isRequired,
};

const enhance = compose(
    connect(mapStateToProps),
);

export default enhance(TwoColumn);
